import {Component, OnInit, ViewChild} from '@angular/core';
import {PrimeNGConfig} from 'primeng/api';
// @ts-ignore
import {AdminDashboardApiService} from '@cas-hub/acabim-common-client';
import {SiteRelatedStatsComponent} from './site-related-stats/site-related-stats.component';

@Component({
    selector: 'acabim-admin-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
    @ViewChild('charts') chart!: SiteRelatedStatsComponent;

    constructor(private primengConfig: PrimeNGConfig) {
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        if (this.chart) {
            this.chart.chart.chart.reinit();
            this.chart.chart.chart.refresh();
        }
    }

}
